import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvViasRiesgosPayload {
  via_id: number;
  zona_id?: number | null;
  codigo: string;
  tipo_riesgo: number;
  tipo_conflicto?: number | null;
  descripcion: string;
  actor_vial_1?: number | null;
  actor_vial_2?: number | null;
  condicion_detectada?: string | null;
  control_existente?: string | null;
  nivel_riesgo?: number | null;
  probabilidad?: number | null;
  consecuencia?: number | null;
  requiere_intervencion?: number;
  prioridad?: number | null;
  estado?: number;
  fecha_identificacion: string;
  observaciones?: string | null;
  created_by?: number | null;
  updated_by?: number | null;
}

/**
 * 🔹 Entidad
 */
export interface PesvViasRiesgos {
  id?: number;
  via_id: number;
  zona_id?: number | null;
  codigo: string;
  tipo_riesgo: number;
  tipo_conflicto?: number | null;
  descripcion: string;
  actor_vial_1?: number | null;
  actor_vial_2?: number | null;
  condicion_detectada?: string | null;
  control_existente?: string | null;
  nivel_riesgo?: number | null;
  probabilidad?: number | null;
  consecuencia?: number | null;
  requiere_intervencion: number;
  prioridad?: number | null;
  estado: number;
  fecha_identificacion: string;
  observaciones?: string | null;
  created_by?: number | null;
  updated_by?: number | null;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvViasRiesgosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvViasRiesgosService {
  private readonly apiUrl = `${environment.apiUrl}/api/pesv_vias_riesgos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los riesgos
   */
  getAll(): Observable<PesvViasRiesgos[]> {
    return this.http.get<PesvViasRiesgos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener riesgo por ID
   */
  getById(id: number): Observable<PesvViasRiesgos> {
    return this.http.get<PesvViasRiesgos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear riesgo
   */
  create(
    payload: PesvViasRiesgosPayload
  ): Observable<PesvViasRiesgosResponse> {
    return this.http.post<PesvViasRiesgosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar riesgo
   */
  update(
    id: number,
    payload: Partial<PesvViasRiesgosPayload>
  ): Observable<PesvViasRiesgosResponse> {
    return this.http.put<PesvViasRiesgosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar riesgo
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar riesgo
   */
  inactivar(id: number): Observable<PesvViasRiesgosResponse> {
    return this.http.put<PesvViasRiesgosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar riesgo
   */
  activar(id: number): Observable<PesvViasRiesgosResponse> {
    return this.http.put<PesvViasRiesgosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  getByIdZonas(zona_id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/zona/${zona_id}`,
      {
        withCredentials: true,
      }
    );
  }
}